import React, { useState, useEffect, useCallback, useRef } from "react";
import { Steps } from "antd";
import { Provider } from "./MultiStepFormContext";
import { useNavigate } from "react-router-dom";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import Step1 from "../../components/all-account-steps/Identity";
import Step2 from "../../components/all-account-steps/BankDetails";
import Step3 from "../../components/all-account-steps/AccountSettings";
import Step4 from "../../components/all-account-steps/Agreement";
import Step5 from "../../components/all-account-steps/OtherOwners";
import Step6 from "../../components/all-account-steps/DirectDebit";
import CircleLoader from "../common/CircleLoader";
import {
  FaDollarSign,
  FaShieldAlt,
  FaLandmark,
  FaFileAlt,
  FaUsers,
  FaCogs
} from "react-icons/fa";
import privateAxios from "../../utils/axiosPrivate";
import useAccountingSoftwareApi from "../../hooks/useAccountingSoftwareApi";
import { showToast } from "../../utils/utils";
import useIdentificationApi from "../../hooks/useIdentificationApi";
import { useSelector, useDispatch } from "react-redux";
import { getOnboardingData } from "../../redux/loginSlice";
import {
  accSoftwarePage,
  accSofywareName,
  headerData,
  onboardingStepData
} from "../../locales/en";
import { accountData as accountDataConstants } from "../../utils/constants/appConstants";
import {
  COMPLETED,
  HTTP_STATUS_SUCCESS
} from "../../utils/constants/appConstants";
import { showToastType } from "../../utils/constants/appConstants";
import "./../../assets/scss/account.scss";
import "./multiStepForm.scss";
import {
  getAccAnnatureStatusURL,
  getLiabltyExpnsStatusUrl,
  getMyobAccExpnsUrl,
  getMyobAccLiabilityUrl,
  getMyobBankAccUrl,
  getOnboarStatusCheckUrl,
  getQuickbooksAccLiabilityUrl,
  getQuickBooksBankAccUrl,
  getQuickbooksExpnsAccUrl,
  getReckonBankAccUrl,
  getReckonTaxGrpsUrl,
  getSecondaryUserUrl,
  getUpdateOnboardStepsUrl,
  getXeroAccLiabilityUrl,
  getXeroBankAccUrl,
  getXeroExpnsAccUrl
} from "../../utils/constants/apiEndPoints";
import { COMPLETE_ACCOUNT_SETUP, INVOICE } from "../../route/paths";
import LoginAsUser from "../loginasuser/LoginAsUser";
import useLoginSuccessToast from "../../hooks/login/useLoginSuccessToast";

const { Step } = Steps;

const identityInitialState = {
  kycIdentity: false
};

const bankDetailsInitialState = {
  businessName: "",
  bankAccountType: "",
  companyEntity: "",
  bankAccount: "",
  confirmAccount: false,
  accountantContact: false,
  accountantFirm: "",
  accountantName: "",
  property: "",
  propertyAddress: "",
  specify: "",
  findFrom: ""
};

const agreementInitialState = {
  agreementFile: ""
};

const otherOwnersInitialState = {
  firstName: "",
  lastName: "",
  email: "",
  isNew: true
};

const directDebitInitialState = {
  address1: "",
  address2: "",
  city: ""
};

const settingsInitialState = {
  feesCode: "",
  feesName: "",
  feesTaxCode: "",
  expanceSelect: "",
  activeFees: false,
  advanceCode: "",
  advanceName: "",
  advanceTaxCode: "",
  liabilitySelect: "",
  activeLiability: false
};

const MultiStepForm = () => {
  useLoginSuccessToast();
  const initialRender = useRef(true);
  const initialBankRender = useRef(true);
  const navigate = useNavigate();
  const { GetConnectedSoftware } = useAccountingSoftwareApi();
  const [connectedSoftName, setConnectedSoftName] = useState("");
  const [isConnectedSoftware, setIsConnectedSoftware] = useState(false);
  const [identity, setIdentity] = useState(identityInitialState);
  const [bankDetails, setBankDetails] = useState(bankDetailsInitialState);
  const [agreement, setAgreement] = useState(agreementInitialState);
  const [otherOwners, setOtherOwners] = useState([otherOwnersInitialState]);
  const [directDebit, setDirectDebit] = useState(directDebitInitialState);
  const [accountSettings, setAccountSettings] = useState(settingsInitialState);
  const [currentStep, setCurrentStep] = useState(0);
  const [stepValue, setStepValue] = useState(0);
  const [bankName, setBankName] = useState("");
  const [expenseAccount, setExpenseAccount] = useState("");
  const [liabilityAccount, setLiabilityAccount] = useState("");
  const [expTaxGroup, setExpTaxGroup] = useState("");
  const [libiTaxGroup, setLibiTaxGroup] = useState("");
  const onBoardingDataRedux = useSelector(
    (state) => state.login.onboardingData
  );
  const [onBoardingData, setOnBoardingData] = useState({});
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [isDemoAccount, setIsDemoAccount] = useState(false);
  const [isNextBankdetails, setIsNextBankdetails] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const intervalRef = useRef(null);
  const identityValue = identity?.kycIdentity;
  const { getIdentification } = useIdentificationApi();
  const [isAplyidMandatory, setIsAplyidMandatory] = useState(true);
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userManagement);
  const forceApplicationStatus =
    profile?.systemSettings?.forceApplicationProcess;
  const userId = profile?.id;
  const [annatureStatusData, setAnnatureStatusData] = useState(null);

  const renderStep = (step) => {
    let steps = [];
    if (isConnectedSoftware) {
      steps = [Step1, Step2, Step3, Step4, Step5, Step6];
    } else {
      steps = [Step1, Step2, Step4, Step5, Step6];
    }
    const SelectedStep = steps[step] ?? Step1;
    return <SelectedStep />;
  };

  const fetchApplyIdStatus = useCallback(async () => {
    try {
      const response = await privateAxios.get(getOnboarStatusCheckUrl);
      const checkStatus = response.data?.data?.status;
      setStatus(checkStatus);
      setIsDemoAccount(response?.data?.data?.isDemoAccount);
      setSuccessMsg(response.data?.message);
      if (checkStatus === true) {
        setIsNextBankdetails(true);
      }
    } catch (error) {
      showToast(error.response?.data?.message, showToastType.error);
    }
  }, []);

  const fetchMandateData = useCallback(async () => {
    try {
      const response = await getIdentification();
      setIsAplyidMandatory(response.data?.data?.isAplyidMandatory);
    } catch {
      //handle error
    }
  }, []);

  useEffect(() => {
    fetchApplyIdStatus();
    fetchMandateData();
    if (!status && !isDemoAccount && isAplyidMandatory) {
      intervalRef.current = setInterval(() => {
        fetchApplyIdStatus();
      }, 10000);
    }
    return () => clearInterval(intervalRef.current);
  }, [
    identityValue,
    fetchApplyIdStatus,
    status,
    isDemoAccount,
    fetchMandateData,
    isAplyidMandatory
  ]);

  // for expense-accounts
  const handleGetReckonExpenseData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getLiabltyExpnsStatusUrl);
      setExpenseAccount(response?.data?.data?.expenseAccountList);
      setLiabilityAccount(response?.data?.data?.liabilityAccountList);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetMyobExpenseData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getMyobAccExpnsUrl);
      setExpenseAccount(response?.data?.data?.Items);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetMyobLiabilityData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getMyobAccLiabilityUrl);
      setLiabilityAccount(response?.data?.data?.Items);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetXeroExpenseData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getXeroExpnsAccUrl);
      setExpenseAccount(response?.data?.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetXeroLiabilityData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getXeroAccLiabilityUrl);
      setLiabilityAccount(response?.data?.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetQuickBooksExpenseData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getQuickbooksExpnsAccUrl);
      setExpenseAccount(response?.data?.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetQuickBooksLiabilityData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getQuickbooksAccLiabilityUrl);
      setLiabilityAccount(response?.data?.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetReckonTaxGroupData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getReckonTaxGrpsUrl);
      setExpTaxGroup(response?.data?.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetMoybExpTaxGroupData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getMyobAccExpnsUrl);
      if (response.data.status === HTTP_STATUS_SUCCESS) {
        const taxCodes = response.data.data.Items.filter((item) => item.TaxCode)
          .map((item) => item.TaxCode)
          .filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.UID === value.UID)
          );

        setExpTaxGroup(taxCodes);
      }
    } catch {
      // handle catch here;
    }
  }, []);

  const handleGetMoybLibiTaxGroupData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getMyobAccLiabilityUrl);
      if (response.data.status === HTTP_STATUS_SUCCESS) {
        const taxCodes = response.data.data.Items.filter((item) => item.TaxCode)
          .map((item) => item.TaxCode)
          .filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.UID === value.UID)
          );

        setLibiTaxGroup(taxCodes);
      }
    } catch {
      // handle catch here;
    }
  }, []);

  const refreshExpenseAccounts = useCallback(async () => {
    if (connectedSoftName === accSoftwarePage?.xero)
      await handleGetXeroExpenseData();
    else if (connectedSoftName === accSofywareName?.quickBooks)
      await handleGetQuickBooksExpenseData();
  }, [
    connectedSoftName,
    handleGetXeroExpenseData,
    handleGetQuickBooksExpenseData
  ]);

  const refreshLiabilityAccounts = useCallback(async () => {
    if (connectedSoftName === accSoftwarePage?.xero)
      await handleGetXeroLiabilityData();
    else if (connectedSoftName === accSofywareName?.quickBooks)
      await handleGetQuickBooksLiabilityData();
  }, [
    connectedSoftName,
    handleGetXeroLiabilityData,
    handleGetQuickBooksLiabilityData
  ]);

  const handlePostReckonBankData = useCallback(async () => {
    try {
      const response = await privateAxios.post(getReckonBankAccUrl);
      setBankName(response.data.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handlePostXeroBankData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getXeroBankAccUrl);
      setBankName(response.data.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handlePostMyobBankData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getMyobBankAccUrl);
      setBankName(response.data.data);
    } catch {
      // handle catch here;
    }
  }, []);

  const handlePostQuickBooksBankData = useCallback(async () => {
    try {
      const response = await privateAxios.get(getQuickBooksBankAccUrl);
      setBankName(response.data.data);
    } catch {
      // handle catch here;
    }
  }, []);

  useEffect(() => {
    const fetchOwnerData = async () => {
      try {
        const isOnCompleteSetupPage =
          location.pathname === COMPLETE_ACCOUNT_SETUP;

        if (!isOnCompleteSetupPage) {
          setOtherOwners([]);
          return;
        }
        const userResponse = await privateAxios.get(getSecondaryUserUrl);
        const apiOwners = userResponse.data.data.map((owner) => ({
          ...owner,
          isNew: false
        }));

        setOtherOwners(apiOwners);
      } catch (error) {
        showToast(error.response.data.message, showToastType.error);
        setOtherOwners([]);
      }
    };
    fetchOwnerData();
  }, []);

  const handleAnnatureCheckStatus = useCallback(async () => {
    try {
      const response = await privateAxios.post(getAccAnnatureStatusURL, null, {
        params: { userAccountId: userId }
      });
      if (response.status === 200) {
        const responseData = response.data.data;
        setAnnatureStatusData(responseData);
      }
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    }
  }, [userId]);

  useEffect(() => {
    handleAnnatureCheckStatus();
  }, [handleAnnatureCheckStatus]);

  const handlePostBankData = useCallback(
    async (accountingSoftwareType) => {
      try {
        switch (accountingSoftwareType) {
          case "Reckon":
            handlePostReckonBankData();
            handleGetReckonExpenseData();
            handleGetReckonTaxGroupData();
            break;
          case "MYOB":
            handlePostMyobBankData();
            handleGetMyobExpenseData();
            handleGetMyobLiabilityData();
            handleGetMoybExpTaxGroupData();
            handleGetMoybLibiTaxGroupData();
            break;
          case "Xero":
            handlePostXeroBankData();
            handleGetXeroExpenseData();
            handleGetXeroLiabilityData();
            break;
          case "QuickBooks":
            handlePostQuickBooksBankData();
            handleGetQuickBooksExpenseData();
            handleGetQuickBooksLiabilityData();
            break;
          default:
            throw new Error("Select a accounting software");
        }
      } catch {
        // error log
      }
    },
    [
      handlePostReckonBankData,
      handlePostMyobBankData,
      handlePostXeroBankData,
      handlePostQuickBooksBankData,
      handleGetReckonExpenseData,
      handleGetMoybExpTaxGroupData,
      handleGetMoybLibiTaxGroupData,
      handleGetMyobExpenseData,
      handleGetMyobLiabilityData,
      handleGetQuickBooksExpenseData,
      handleGetQuickBooksLiabilityData,
      handleGetReckonTaxGroupData,
      handleGetXeroExpenseData,
      handleGetXeroLiabilityData
    ]
  );

  const checkSoftwareConnected = useCallback(async () => {
    try {
      const response = await GetConnectedSoftware();
      setConnectedSoftName(response?.data?.data?.accountingSoftwareType);
      handlePostBankData(response?.data?.data?.accountingSoftwareType);
      setIsConnectedSoftware(response?.data?.data?.isConnected);
    } catch (err) {
      showToast(err?.response?.data?.message, showToastType.error);
    }
  }, [GetConnectedSoftware, handlePostBankData]);

  // for updating data

  const updateJsonValues = (obj, updates) => {
    if (typeof obj !== "object" || obj === null) return obj;
    const updatedObj = { ...obj };
    for (const key in updatedObj) {
      if (Object.prototype.hasOwnProperty.call(updatedObj, key)) {
        if (Object.prototype.hasOwnProperty.call(updates, key)) {
          updatedObj[key] = updates[key];
        }
        if (typeof updatedObj[key] === "object") {
          updatedObj[key] = updateJsonValues(updatedObj[key], updates);
        }
      }
    }
    return updatedObj;
  };

  const handleUpdateOnboarding = async (
    originalName,
    finalValue,
    isNextStep = false,
    overrides = {}
  ) => {
    try {
      if (originalName === "onboardingStepsCompleted") {
        const newValue = finalValue;
        if (newValue <= stepValue) {
          return;
        }
      }
      const updateData = {
        hearAboutUs: bankDetails?.findFrom,
        hearAboutUsOther: bankDetails?.specify,
        isAllowedContactAccountant: bankDetails?.accountantContact,
        legalName: bankDetails?.businessName,
        organisationTypes: bankDetails?.companyEntity,
        accountantName: bankDetails?.accountantName,
        accountingFirmName: bankDetails?.accountantFirm,
        propertyOwnership: bankDetails?.property,
        propertyOwnedAdddress: bankDetails?.propertyAddress,
        bankAccount: {
          accountUuid: bankDetails?.bankAccountType,
          isBankAccountConfirmed: bankDetails?.confirmAccount,
          accountCode: bankDetails?.bankAccount
        },

        expenseAccountCode: accountSettings?.feesCode,
        expenseAccountName: accountSettings?.feesName,
        expenseAccountTaxCode: accountSettings?.feesTaxCode,
        expenseAccountUuid: accountSettings?.expanceSelect,
        isUsedExisitingExpenseAccount: accountSettings?.activeFees,
        liabilityAccountCode: accountSettings?.advanceCode,
        liabilityAccountName: accountSettings?.advanceName,
        liabilityAccountTaxCode: accountSettings?.advanceTaxCode,
        liabilityAccountUuid: accountSettings?.liabilitySelect,
        isUsedExistingLiabilityAccount: accountSettings?.activeLiability
      };
      const stepsCompleted = isNextStep ? currentStep : stepValue;
      const finalPayload = {
        ...updateJsonValues(updateData, {
          [originalName]: finalValue,
          ...overrides
        }),
        onboardingStepsCompleted:
          originalName === "onboardingStepsCompleted"
            ? finalValue
            : stepsCompleted
      };
      privateAxios.put(getUpdateOnboardStepsUrl, finalPayload);
    } catch {
      // for error message
    }
  };

  const next = () => {
    const nextStep = currentStep + 1;
    if (nextStep > stepValue) {
      handleUpdateOnboarding("onboardingStepsCompleted", nextStep, true);
      setStepValue(nextStep);
    }
    setCurrentStep(nextStep);

    if (nextStep) {
      dispatch(getOnboardingData());
    }
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
    setIsNextBankdetails(false);
  };

  useEffect(() => {
    if (onBoardingData) {
      setIdentity((prev) => ({
        ...prev,
        kycIdentity: onBoardingData.isCreditConsentAccepted ?? false
      }));

      setBankDetails((prev) => ({
        ...prev,
        bankAccountType: onBoardingData?.bankAccount?.accountUuid ?? "",
        bankAccount: onBoardingData?.bankAccount?.accountCode ?? "",
        confirmAccount: onBoardingData?.bankAccount?.isBankAccountConfirmed,
        businessName: onBoardingData?.legalName,
        companyEntity: onBoardingData?.organisationTypes,
        accountantContact: onBoardingData?.isAllowedContactAccountant ?? false,
        accountantFirm: onBoardingData?.accountingFirmName ?? "",
        accountantName: onBoardingData?.accountantName ?? "",
        property: onBoardingData?.propertyOwnership,
        propertyAddress: onBoardingData?.propertyOwnedAdddress ?? "",
        specify: onBoardingData?.hearAboutUsOther ?? "",
        findFrom: onBoardingData?.hearAboutUs ?? ""
      }));

      setAccountSettings((prev) => ({
        ...prev,
        feesCode:
          onBoardingData?.expenseAccountCode ??
          accountDataConstants.defaultFeesCode,
        feesName:
          onBoardingData?.expenseAccountName ??
          accountDataConstants.defaultFeesName,
        feesTaxCode: onBoardingData?.expenseAccountTaxCode,
        expanceSelect: onBoardingData?.expenseAccountUuid,
        activeFees: onBoardingData?.isUsedExisitingExpenseAccount ?? false,
        advanceCode:
          onBoardingData?.liabilityAccountCode ??
          accountDataConstants.defaultAdvanceCode,
        advanceName:
          onBoardingData?.liabilityAccountName ??
          accountDataConstants.defaultAdvanceName,
        advanceTaxCode: onBoardingData?.liabilityAccountTaxCode,
        liabilitySelect: onBoardingData?.liabilityAccountUuid,
        activeLiability: onBoardingData?.isUsedExistingLiabilityAccount ?? false
      }));

      setCurrentStep(onBoardingData?.onboardingStepsCompleted ?? 0);
      setStepValue(onBoardingData?.onboardingStepsCompleted ?? 0);
    }
  }, [onBoardingData]);

  useEffect(() => {
    const handleGetOnboardingData = async () => {
      try {
        setLoading(true);
        const response = await dispatch(getOnboardingData()).unwrap();
        setOnBoardingData(response?.data?.data);
      } catch (error) {
        showToast(error.response?.data?.message, showToastType.error);
      } finally {
        setLoading(false);
      }
    };

    if (initialRender.current) {
      handleGetOnboardingData();
      initialRender.current = false;
    }
  }, [dispatch]);

  useEffect(() => {
    if (initialBankRender.current && identity?.kycIdentity) {
      checkSoftwareConnected();
      handlePostBankData();
      initialBankRender.current = false;
    }
  }, [checkSoftwareConnected, identity?.kycIdentity, dispatch]);

  useEffect(() => {
    if (
      onBoardingDataRedux?.onboardingStatus === COMPLETED &&
      forceApplicationStatus === false
    ) {
      navigate(INVOICE);
    }
  }, [onBoardingDataRedux, forceApplicationStatus, navigate]);

  // Dynamically build steps array based on connectedSoftName
  const stepsList = [
    { title: onboardingStepData?.step1, icon: <FaShieldAlt /> },
    { title: onboardingStepData?.step2, icon: <FaLandmark /> }
  ];

  const getAdditionalSteps = () => {
    if (isConnectedSoftware) {
      return [
        { title: onboardingStepData?.step3, icon: <FaCogs /> },
        { title: onboardingStepData?.step4, icon: <FaFileAlt /> },
        { title: onboardingStepData?.step5, icon: <FaUsers /> },
        { title: onboardingStepData?.step6, icon: <FaDollarSign /> }
      ];
    }

    return [
      {
        title: onboardingStepData?.withoutConnected?.step3,
        icon: <FaFileAlt />
      },
      { title: onboardingStepData?.withoutConnected?.step4, icon: <FaUsers /> },
      {
        title: onboardingStepData?.withoutConnected?.step5,
        icon: <FaDollarSign />
      }
    ];
  };

  stepsList.push(...getAdditionalSteps());

  if (loading) {
    return <CircleLoader />;
  }

  return (
    <div
      className={`steplist-wrap ${
        !isConnectedSoftware ? "withoutaccounting-step" : ""
      }`}
    >
      <HeaderDashboard />
      <LoginAsUser />

      <div className="container">
        <div className="row">
          <div className="home-main-section mb-5">
            <div className="container">
              <div className="home-title">
                <h1>{headerData.myAccount}</h1>
              </div>
            </div>
          </div>
          <Provider
            value={{
              identity,
              setIdentity,
              next,
              prev,
              bankDetails,
              setBankDetails,
              agreement,
              setAgreement,
              otherOwners,
              setOtherOwners,
              directDebit,
              setDirectDebit,
              bankName,
              connectedSoftName,
              accountSettings,
              setAccountSettings,
              expenseAccount,
              liabilityAccount,
              expTaxGroup,
              libiTaxGroup,
              handleUpdateOnboarding,
              refreshExpenseAccounts,
              refreshLiabilityAccounts,
              onBoardingData,
              successMsg,
              status,
              isDemoAccount,
              isAplyidMandatory,
              isNextBankdetails,
              setIsNextBankdetails,
              isConnectedSoftware,
              userId,
              annatureStatusData,
              handleAnnatureCheckStatus
            }}
          >
            <Steps
              current={currentStep}
              onChange={(step) => {
                if (step <= stepValue) {
                  setCurrentStep(step);
                  setIsNextBankdetails(false);
                }
              }}
            >
              {stepsList.map((step, idx) => (
                <Step key={idx} title={step.title} icon={step.icon} />
              ))}
            </Steps>
            <main>{renderStep(currentStep)}</main>
          </Provider>
        </div>
      </div>
    </div>
  );
};
export default MultiStepForm;
